export const DailyRewards = [1, 2, 4, 8, 12, 24, 48];
